<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-12">
        <div class="row">
          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [required]="true" [onlyConfigured]="true"></app-company-selector>
          </div>
          <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear" [required]="true">
            </app-year-selector>
          </div>

          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <mat-select data-size="7" [(ngModel)]="firstHolidays" name="firmado"
                placeholder="Primer periodo de vacaciones">
                <mat-option [value]="true">Sí</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany  || firstHolidays == undefined"
              (click)="onSearch()">Buscar</button>
          </div>
        </div>
      </div>
    </div>


    <dx-data-grid #gridLiquidacion [dataSource]="holidaysExtraPays" [allowColumnResizing]="true"
      [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)">
      <dxo-selection [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'" mode="multiple"></dxo-selection>

      <!-- Definición de las columnas -->
      <dxi-column caption="Empresa" alignment="center">
        <dxi-column dataField="CodigoEmpresa" caption="Código" alignment="center"></dxi-column>
        <dxi-column dataField="DescripcionEmpresa" caption="Empresa"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Centro" alignment="center">
        <dxi-column dataField="CodigoCentro" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="DescripcionCentro" caption="Centro"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Imputación" alignment="center">
        <dxi-column dataField="CodigoImputacion" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="DescripcionImputacion" caption="Imputacion"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Trabajador" alignment="center">
        <dxi-column dataField="CodigoTrabajador" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="NombreTrabajador" caption="Trabajador"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Datos del trabajador" alignment="center">
        <dxi-column dataField="Ejercicio" caption="Ejercicio" alignment="center"> </dxi-column>
        <dxi-column dataField="DiasITAbsentismo" caption="Días IT" alignment="center"> </dxi-column>
        <dxi-column dataField="ImporteBolsa" caption="Importe bolsa">
          <dxo-format type="currency" [precision]="2"></dxo-format>
        </dxi-column>
        <dxi-column dataField="ImporteProporcional" caption="Importe proporcional">
          <dxo-format type="currency" [precision]="2"></dxo-format>
        </dxi-column>
        <dxi-column dataField="ImporteCobrado" caption="Cobrado">
          <dxo-format type="currency" [precision]="2"></dxo-format>
        </dxi-column>
        <dxi-column dataField="Importe" caption="Total">
          <dxo-format type="currency" [precision]="2"></dxo-format>
        </dxi-column>
      </dxi-column>
      <dxi-column caption="Vacaciones" alignment="center" *ngIf="showFirstHolidaysData">
        <dxi-column dataField="periodos" caption="Inicio" [calculateCellValue]="getFirstHolidayStarDate">
        </dxi-column>
        <dxi-column dataField="periodos" caption="Fin" [calculateCellValue]="getFirstHolidayEndDate">
        </dxi-column>
        <dxi-column dataField="periodos" caption="Días" [calculateCellValue]="getFirstHolidayTotalDays">
        </dxi-column>
      </dxi-column>


      <dxo-export [enabled]="true"></dxo-export>

    </dx-data-grid>

    <div class="row" style="margin-top: 20px;">
      <div class="col-2 ml-auto">
        <mat-form-field>
          <input matInput #inputFechaLiquidacion [matDatepicker]="pickerFechaLiquidacion" [(ngModel)]="fechaLiquidacion"
            [ngModelOptions]="{updateOn: 'blur'}" name="fechaLiquidacion" (click)="pickerFechaLiquidacion.open()"
            placeholder="Fecha" required [max]="maxDate" [min]="minDate" />
          <mat-datepicker-toggle matSuffix [for]="pickerFechaLiquidacion"></mat-datepicker-toggle>
          <mat-datepicker #pickerFechaLiquidacion></mat-datepicker>

        </mat-form-field>
      </div>
      <div class="col-auto">
        <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany || firstHolidays == undefined"
          (click)="generarLiquidacion()">Generar
          liquidación</button>
      </div>
    </div>
  </app-generic-panel>
  <br>
</app-generic-container>
